import React, { useState } from 'react';
import TextAreaInput from './text-area-input';

const TextAreaSlide = ({ initialData, onUpdate, label }) => {
  const [value, setValue] = useState(initialData);

  const handleInputChange = (e) => {
    setValue(e.target.value);
  };

  const updateLetterData = () => {
    onUpdate(value);
  };

  return (
    <TextAreaInput
      autoFocus
      inputValue={value}
      onInputChange={handleInputChange}
      onBlur={updateLetterData}
      label={label}
      id={'letterslide-textarea-slide'}
    />
  );
};

export default TextAreaSlide;
